import { render, staticRenderFns } from "./ErpPasswordChangeHist.vue?vue&type=template&id=58812433&scoped=true&"
import script from "./ErpPasswordChangeHist.vue?vue&type=script&lang=js&"
export * from "./ErpPasswordChangeHist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58812433",
  null
  
)

export default component.exports